import { render } from "./BrowseTms.vue?vue&type=template&id=0fdc3dc7&scoped=true"
import script from "./BrowseTms.vue?vue&type=script&lang=js"
export * from "./BrowseTms.vue?vue&type=script&lang=js"

import "./BrowseTms.vue?vue&type=style&index=0&id=0fdc3dc7&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fdc3dc7"]])

export default __exports__